import React from "react";
import { Helmet } from "react-helmet-async";
import { MdFavoriteBorder } from "react-icons/md";

import styles from "./Favorite.module.scss";
import { useFavorite } from "./useFavorite";
import { PageHeader } from "../../../common/components/pageHeader/PageHeader";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import { PROFILE_ROUTE } from "../../../common/utils/constants";
import { FavoriteItem } from "./FavoriteItem";

export const Favorite: React.FC = () => {
  const {
    available,
    unavailable,
    ready,
    removingId,
    isFetchingMore,
    lastItemRef,
    removeFavorite,
  } = useFavorite();

  const total = available.length + unavailable.length;

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Избранное — ЛОГМОЛЛ</title>
      </Helmet>

      <PageHeader title="Избранное" backRoute={PROFILE_ROUTE} />

      {!ready ? null : total === 0 ? (
        <EmptyState
          icon={MdFavoriteBorder}
          title="В избранном пусто"
          description="Добавляйте товары, чтобы не потерять."
        />
      ) : (
        <>
          {available.length > 0 && (
            <div className={styles.List}>
              {available.map((item, index) => {
                const isLast = index === available.length - 1;
                return (
                  <FavoriteItem
                    key={item.id}
                    item={item}
                    removing={removingId === item.id}
                    onRemove={removeFavorite}
                    lastItemRef={isLast ? lastItemRef : undefined}
                  />
                );
              })}
            </div>
          )}

          {unavailable.length > 0 && (
            <>
              <h3 className={styles.SectionTitle}>Недоступны в вашем городе</h3>
              <div className={styles.List}>
                {unavailable.map((item, index) => {
                  const isLast = index === unavailable.length - 1;
                  return (
                    <FavoriteItem
                      key={item.id}
                      item={item}
                      unavailable
                      removing={removingId === item.id}
                      onRemove={removeFavorite}
                      lastItemRef={
                        available.length === 0 && isLast
                          ? lastItemRef
                          : undefined
                      }
                    />
                  );
                })}
              </div>
            </>
          )}

          {isFetchingMore && <div className={styles.Loader}>Загрузка...</div>}
        </>
      )}
    </div>
  );
};